import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class ArtisanSmithBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.ARTISAN_SMITH;
}

export default ArtisanSmithBuildingTileEntity;
